export default {
  signIn: 'Войти',
  signOut: 'Выйти',
  points: 'баллы',
  hyattSignInButton: 'Войдите в World of Hyatt',
};
